<template>
    <Question>
      <router-view></router-view>
    </Question>
</template>

<script>
import Question from '../components/question'
export default {
  name: "index",
  components:{Question}
}
</script>

<style scoped>


</style>